import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import {
  GetConveyorTemplates,
  GetConveyorTemplateById,
  UpdateConveyorTemplate,
  UpdateConveyorStepTemplate,
  GetConveyorStepTemplateById,
  ChangeConveyorTemplateInactiveStatus,
  ChangeConveyorStepTemplateInactiveStatus,
  GetFactoryIcons,
} from './thunks';

import {
  GetConveyorTemplatesReducer,
  GetConveyorTemplateByIdReducer,
  UpdateConveyorTemplateReducer,
  ClearSelectedConveyorTemplateReducer,
  UpdateConveyorStepTemplateReducer,
  GetConveyorStepTemplateByIdReducer,
  ClearSelectedConveyorStepTemplateReducer,
  ResetConveyorTemplatesReducer,
  ChangeConveyorTemplateInactiveStatusReducer,
  ChangeConveyorStepTemplateInactiveStatusReducer,
  GetFactoryIconsReducer,
} from './reducers';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'conveyorTemplates',
  initialState,
  reducers: {
    ClearSelectedConveyorTemplate: ClearSelectedConveyorTemplateReducer,
    ClearSelectedConveyorStepTemplate: ClearSelectedConveyorStepTemplateReducer,
    ResetConveyorTemplates: ResetConveyorTemplatesReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetConveyorTemplates, GetConveyorTemplatesReducer);
    addExtraReducer(builder, GetConveyorTemplateById, GetConveyorTemplateByIdReducer);
    addExtraReducer(builder, GetConveyorStepTemplateById, GetConveyorStepTemplateByIdReducer);
    addExtraReducer(builder, UpdateConveyorTemplate, UpdateConveyorTemplateReducer);
    addExtraReducer(builder, UpdateConveyorStepTemplate, UpdateConveyorStepTemplateReducer);
    addExtraReducer(builder, ChangeConveyorTemplateInactiveStatus, ChangeConveyorTemplateInactiveStatusReducer);
    addExtraReducer(builder, ChangeConveyorStepTemplateInactiveStatus, ChangeConveyorStepTemplateInactiveStatusReducer);
    addExtraReducer(builder, GetFactoryIcons, GetFactoryIconsReducer);
  },
});

export default slice.reducer;
